'use client';

import { useRouter } from "next/navigation";
import { Suspense } from "react";
import { Card } from "./ui/card";
import { Button } from "./ui/button";
import { Check } from "lucide-react";

function PricingContent() {
  const router = useRouter();

  const onGetStarted = () => {
    router.push(`/create-account`);
  };

  const plans = [
    {
      name: "Basic",
      price: "$29.99",
      period: "/month",
      highlighted: false,
      features: [
        "800 pages per month",
        "Advanced text & table extraction",
        "Form field detection",
        "Priority API access",
      ],
    },
    {
      name: "Pro",
      price: "$79.99",
      period: "/month",
      highlighted: true,
      features: [
        "3000 pages per month",
        "All Basic features",
        "Custom schemas",
        "CSV export",
        "Email support",
      ],
    },
    {
      name: "Enterprise",
      price: "$129.99",
      period: "/month",
      highlighted: false,
      features: [
        "10,000 pages per month",
        "All Pro features",
        "Dedicated support",
      ],
    },
  ];

  return (
    <section id="pricing" className="container mx-auto px-4 py-16 md:py-24">
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-mono">Pricing</h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto">
        {plans.map((plan, index) => (
          <Card
            key={index}
            className={`p-8 flex flex-col ${plan.highlighted ? 'bg-primary text-primary-foreground border-primary' : ''}`}
          >
            <div className="flex flex-col flex-1 space-y-6">
              <div>
                <h3 className={`text-xl mb-2 font-mono ${plan.highlighted ? 'text-primary-foreground' : ''}`}>
                  {plan.name}
                </h3>
                <div className="flex items-baseline gap-1">
                  <span className={`text-3xl font-mono ${plan.highlighted ? 'text-primary-foreground' : ''}`}>
                    {plan.price}
                  </span>
                  <span className={`text-sm ${plan.highlighted ? 'text-primary-foreground/70' : 'text-muted-foreground'}`}>
                    {plan.period}
                  </span>
                </div>
              </div>

              <ul className="space-y-3 flex-1">
                {plan.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-start gap-2 text-sm">
                    <Check className={`w-4 h-4 mt-0.5 flex-shrink-0 ${plan.highlighted ? 'text-primary-foreground' : ''}`} />
                    <span className={plan.highlighted ? 'text-primary-foreground' : ''}>
                      {feature}
                    </span>
                  </li>
                ))}
              </ul>

              <Button
                variant={plan.highlighted ? "secondary" : "outline"}
                className="w-full font-mono"
                onClick={onGetStarted}
              >
                Get Started
              </Button>
            </div>
          </Card>
        ))}
      </div>
    </section>
  );
}

export default function Pricing() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <PricingContent />
    </Suspense>
  );
}
